module.exports = __webpack_public_path__ + "static/img/left-top-corner.b74785b0.png";